module.exports = __webpack_public_path__ + "static/img/Captura.7a26adb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Captura.png
// module id = ISX7
// module chunks = 5